import * as React from "react"

import { cn } from "@/lib/utils"
import {Button} from "@/components/ui/button.tsx";
import {EyeIcon, EyeSlashIcon} from "@heroicons/react/24/outline";

const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, ...props }, ref) => {

      const [type, setType] = React.useState("password");

      function toggleType() {
            setType(type === "password" ? "text" : "password");
      }

    return (
        <div className="relative w-full">
            <input
                type={type}
                className={cn(
                    "flex h-10 w-full border-gray-300 rounded-lg focus:outline-none focus:border-light-blue-500 border  bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-neutral-950 placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-neutral-950 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutral-800 dark:file:text-neutral-50 dark:placeholder:text-neutral-400 dark:focus-visible:ring-neutral-300",
                    className
                )}
                ref={ref}
                {...props}
            />
            <Button
                variant="ghost"
                size="icon"
                type="button"
                onClick={toggleType}
                className="absolute end-2 cursor-pointer top-1/2 -translate-y-1/2 h-6 w-6"
            >
                {type === "password" ? (
                    <EyeIcon className="w-5 h-5"/>
                ) : (
                    <EyeSlashIcon className="w-5 h-5"/>
                )}
            </Button>
        </div>
    )
  }
)
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
